import config from '@/config/serviceWorker';

// Create a configuration object that will be injected into the service worker
const serviceWorkerConfig = {
  enabled: process.env.NODE_ENV === 'production' && config.enabled,
  cacheEnabled: process.env.NODE_ENV === 'production' && config.cacheEnabled,
  cacheName: config.cacheName,
  urlsToCache: config.urlsToCache,
  updateInterval: config.updateInterval,
  skipWaiting: config.skipWaiting,
  clientsClaim: config.clientsClaim
};

export async function registerServiceWorker() {
  // Double-check we're in production
  if (process.env.NODE_ENV !== 'production') {
    console.log('Service worker registration skipped in development mode');
    return;
  }

  if (!serviceWorkerConfig.enabled) {
    console.log('Service worker is disabled by configuration');
    return;
  }

  if (!('serviceWorker' in navigator)) {
    console.log('Service workers are not supported in this browser');
    return;
  }

  try {
    // Register new service worker with configuration
    const registration = await navigator.serviceWorker.register('/portal/service-worker.js', {
      scope: '/',
      updateViaCache: 'none'
    });

    console.log('Service worker registered successfully:', registration);

    // Wait for the service worker to be ready before sending config
    if (registration.installing) {
      registration.installing.addEventListener('statechange', (event) => {
        const worker = event.target as ServiceWorker;
        if (worker.state === 'activated') {
          // Send configuration to the newly activated worker
          worker.postMessage({
            type: 'CONFIG',
            config: serviceWorkerConfig
          });
          console.log('Configuration sent to activated service worker');
        }
      });
    }

    if (registration.active) {
      // Send configuration to already active worker
      registration.active.postMessage({
        type: 'CONFIG',
        config: serviceWorkerConfig
      });
      console.log('Configuration sent to active service worker');
    }

    // Check for updates periodically
    setInterval(() => {
      registration.update().catch((error) => {
        console.warn('Service worker update check failed:', error);
      });
    }, serviceWorkerConfig.updateInterval);

    // Handle updates
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      if (newWorker) {
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('New service worker version available');
          }
        });
      }
    });

  } catch (error) {
    console.error('Service worker registration failed:', error);
    // Don't throw - allow the app to continue without service worker
  }
}

export async function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.ready;
      await registration.unregister();
      console.log('Service worker unregistered successfully');
    } catch (error) {
      console.error('Service worker unregistration failed:', error);
    }
  }
} 